/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_List_Actions_LabelInputs */

const en_markers_list_actions_label = /** @type {(inputs: Markers_List_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marker list actions`)
};

const fr_markers_list_actions_label = /** @type {(inputs: Markers_List_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions de liste de marqueurs`)
};

const de_markers_list_actions_label = /** @type {(inputs: Markers_List_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen in der Markerliste`)
};

const it_markers_list_actions_label = /** @type {(inputs: Markers_List_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni dell'elenco dei marcatori`)
};

const ru_markers_list_actions_label = /** @type {(inputs: Markers_List_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действия списка маркеров`)
};

const es_markers_list_actions_label = /** @type {(inputs: Markers_List_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones de la lista de marcadores`)
};

const zh_cn2_markers_list_actions_label = /** @type {(inputs: Markers_List_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标记列表操作`)
};

const ja_markers_list_actions_label = /** @type {(inputs: Markers_List_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーリストのアクション`)
};

const hi_markers_list_actions_label = /** @type {(inputs: Markers_List_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर सूची क्रियाएँ`)
};

const pt_pt2_markers_list_actions_label = /** @type {(inputs: Markers_List_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações da lista de marcadores`)
};

/**
* | output |
* | --- |
* | "Marker list actions" |
*
* @param {Markers_List_Actions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_list_actions_label = /** @type {((inputs?: Markers_List_Actions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_List_Actions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_list_actions_label(inputs)
	if (locale === "de") return de_markers_list_actions_label(inputs)
	if (locale === "it") return it_markers_list_actions_label(inputs)
	if (locale === "ru") return ru_markers_list_actions_label(inputs)
	if (locale === "es") return es_markers_list_actions_label(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_list_actions_label(inputs)
	if (locale === "ja") return ja_markers_list_actions_label(inputs)
	if (locale === "hi") return hi_markers_list_actions_label(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_list_actions_label(inputs)
	return en_markers_list_actions_label(inputs)
});